import firebase from '../../firebase-integration/index';

import { ILeadersListConfig } from '../../store/leaders/reducers';
import { ILeadersListResponse } from '../interfaces/leaders';

const db = firebase.firestore();
const leadersCollection = db.collection('users');
const followingCollection = db.collection('groups');

export const getLeaderGroups = async (ownerId: string): Promise<any> => {
  const results = await followingCollection
    .where('ownerId', '==', ownerId)
    .where('archived', '==', false)
    .get();

  const response: any[] = [];
  results.forEach((data) => {
    response.push({
      id: data.id,
      name: data.data().name,
      ownerId: data.data().ownerId,
      type: data.data().type,
    });
  });

  return response;
};

export const getLeaders =
  async (currUser: any, config: ILeadersListConfig): Promise<ILeadersListResponse> => {
    const documentQuery = await leadersCollection
      .where('searchTerms', 'array-contains', config.search.toLowerCase())
      // .where('email', '!=', currUser.email)
      .orderBy('displayName')
      .limit(config.pagination.limit)
      .get();

    const leadersArray: any[] = [];
    documentQuery.forEach((data: any) => {
      const leaderData = data.data();
      const itemData = {
        id: data.id,
        name: leaderData.leaderName,
        displayName: leaderData.displayName,
        photoUrl: leaderData.photoUrl || '',
      };
      leadersArray.push(itemData);
    });

    return {
      leaders: leadersArray,
      lastItem: documentQuery.docs[documentQuery.docs.length - 1],
    };
  };
